import { Component, inject } from '@angular/core';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { SettingsService } from '@lib/setting/settings.service';
import { createHandbackReasonFormGroup, HandbackReasons, HandbackReasonSingleResponse, StoreHandbackReasonRequest } from '@lib/api/models/setting';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';

@Component({
    selector: 'app-edit-handback-reason-dialog',
    imports: [
        ComponentsModule,
        ErrorPanelComponent,
        ReactiveFormsModule
    ],
    templateUrl: './edit-handback-reason-dialog.component.html',
    standalone: true,
    styleUrl: './edit-handback-reason-dialog.component.scss'
})
export class EditHandbackReasonDialogComponent {

    private readonly _settingService = inject(SettingsService);
    private readonly _snackBar = inject(SnackBarService);

    protected readonly handbackReason = inject<HandbackReasons>(DIALOG_DATA);

    protected readonly handbackReasonFormGroup = createHandbackReasonFormGroup(this.handbackReason);

    protected readonly dialogRef = inject<DialogRef>(DialogRef);

    updateHandbackReason = new SendableRequest<HandbackReasonSingleResponse, StoreHandbackReasonRequest>({
        request: (payload) => this._settingService.updateHandbackReason(this.handbackReason.id, payload!),

        onSend: () => {
            this.handbackReasonFormGroup.disable();
        },

        onSuccess: () => {
            this.handbackReasonFormGroup.enable();

            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Handback Reason edited successfully',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });

            this.dialogRef.close();
        },

        onError: () => {
            this.handbackReasonFormGroup.enable();

            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Handback Reason failed to edit',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });

        }
    });

    update() {
        if (this.updateHandbackReason.loading()) {
            return;
        }

        const handbackReasonData: StoreHandbackReasonRequest = {
            ...this.handbackReason,
            name: this.handbackReasonFormGroup.get('name')?.value ?? '',
            description: this.handbackReasonFormGroup.get('description')?.value ?? ''
        };
        this.updateHandbackReason.send(handbackReasonData);
    }

    public static show(dialog: DialogService, data: HandbackReasons) {
        return dialog.openDialog<DialogRef, HandbackReasons>(EditHandbackReasonDialogComponent, {
            data
        });
    }

}
